var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "900px", persistent: "" },
      model: {
        value: _vm.open,
        callback: function($$v) {
          _vm.open = $$v
        },
        expression: "open"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "d-flex align-center" },
            [
              _c("div", [
                _c("div", { staticClass: "text-h6" }, [
                  _vm._v("Running Balance")
                ]),
                _vm.userLabel
                  ? _c("div", { staticClass: "text-caption" }, [
                      _vm._v(" " + _vm._s(_vm.userLabel) + " ")
                    ])
                  : _vm._e()
              ]),
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.close } },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              )
            ],
            1
          ),
          _c("v-card-text", [
            _vm.loading
              ? _c(
                  "div",
                  { staticClass: "py-8 d-flex justify-center" },
                  [
                    _c("v-progress-circular", {
                      attrs: { indeterminate: "", size: "36" }
                    })
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    !_vm.rows.length
                      ? _c("v-alert", { attrs: { type: "info", dense: "" } }, [
                          _vm._v(" No transactions found. ")
                        ])
                      : _c("v-data-table", {
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.rows,
                            "items-per-page": 15,
                            dense: ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item.amount",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.formatAmount(item.amount))
                                    )
                                  ])
                                ]
                              }
                            },
                            {
                              key: "item.running_balance",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatAmount(item.running_balance)
                                      )
                                    )
                                  ])
                                ]
                              }
                            },
                            {
                              key: "item.transdate",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.formatDate(item.transdate))
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                  ],
                  1
                )
          ]),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "grey", text: "" },
                  on: { click: _vm.close }
                },
                [_vm._v("Close")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }